import { headers } from 'services/auth'
import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL
const DOWNLOAD_DOCS = `${API_URL}/searchdoc`

export const downloadDocs = path =>
  axios.post(
    DOWNLOAD_DOCS,
    { path },
    {
      headers: {
        ...headers(),
        'Content-Type': 'application/json',
        Accept: 'application/pdf',
      },
    },
  )
